import script from "./Disbursements.vue?vue&type=script&setup=true&lang=ts"
export * from "./Disbursements.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/certification-updates/base.css?vue&type=style&index=0&id=07a60940&scoped=true&lang=css"
import "@/styles/certification-updates/disbursements.css?vue&type=style&index=1&id=07a60940&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a60940"]])

export default __exports__